import { render, staticRenderFns } from "./createRegulationModal.vue?vue&type=template&id=d73520b0&scoped=true&"
import script from "./createRegulationModal.vue?vue&type=script&lang=js&"
export * from "./createRegulationModal.vue?vue&type=script&lang=js&"
import style0 from "./createRegulationModal.vue?vue&type=style&index=0&id=d73520b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73520b0",
  null
  
)

export default component.exports